import { KeyAssetType, KeyImageType, KeyTextType } from 'types';
import { updateSlideEffectText } from '../core/mutations';
import { replaceMainImage } from '../modules/slideshow/mutations';
import { updateTextOverlayText } from '../modules/text/mutations';
import { AddTextOverlayOptions } from '../modules/text/types';
import { VideoTemplateStateContent } from '../types';
import { updateState } from './mutations';

export function replaceKeyTextAsset(
  state: VideoTemplateStateContent,
  type: KeyTextType,
  value: string,
  opts?: AddTextOverlayOptions,
): VideoTemplateStateContent {
  const { [type]: textAsset } = state;

  if (!textAsset?.id) return state;

  if (textAsset.type === 'textOverlay') {
    return updateTextOverlayText(state, textAsset.id, value, opts);
  }

  if (textAsset.type === 'slideEffectText') {
    return updateSlideEffectText(state, textAsset.id, value, opts);
  }

  return state;
}

export function replaceKeyAsset(
  state: VideoTemplateStateContent,
  type: KeyImageType,
  src: string | Blob,
): VideoTemplateStateContent;
export function replaceKeyAsset(
  state: VideoTemplateStateContent,
  type: KeyTextType,
  text: string,
): VideoTemplateStateContent;
export function replaceKeyAsset(
  state: VideoTemplateStateContent,
  type: KeyAssetType,
  value: any,
) {
  if (type === 'mainImage') {
    return updateState(replaceMainImage(state, value), {
      mainImage: {
        src: value,
      },
    });
  }
  return replaceKeyTextAsset(state, type, value);
}
